import PropTypes from 'prop-types';
import { useSlideDown } from '../hooks/useSlideDown';
import { getBadge } from '../utils/package';
import List from './List';
import Radio from './ui/Radio';
import Switch from './ui/Switch';

export default function Package({ allowMultiple, id, data, getLabel, addPackage, removePackage, selected, paymentInterval }) {
	const { show, toggle, slideDownRef } = useSlideDown(false);
	const packageFeatureListItems = (data.content?.includes ?? []).map((item) => ({ name: item }));
	const isOptional = !data.required && !data.included;

	const getCostTypeLabel = () => getLabel(data.recurringCosts ? `quote_recurring_${paymentInterval}` : 'package_cost_type_one_time');

	const onChange = (key, checked) => {
		const packageId = parseInt(key);
		if (checked) {
			addPackage(packageId);
		} else {
			removePackage(packageId);
		}
	};

	const getAction = () => {
		if (allowMultiple) {
			return <Switch name="package" value={id.toString()} callback={onChange} disabled={!isOptional} checked={selected} testId="prc-package-input" />;
		} else {
			return isOptional ? <Radio name="package" value={id.toString()} callback={onChange} checked={selected} testId="prc-package-input" /> : null;
		}
	};

	const classes = ['prc-package'];
	if (show) classes.push('prc-package--open');

	return (
		<li className={classes.join(' ')} id={`prc-package-${data.key}`}>
			<div className="prc-package__tab">
				<span className="prc-package__indicator" onClick={toggle}></span>
				<div className="prc-package__name" onClick={toggle} data-testid="prc-package-tab-name">
					{data.name}
					<p className="prc-package__badge-mobile">{getBadge(data, getLabel)}</p>
				</div>
				<div className="prc-package__badge">{getBadge(data, getLabel)}</div>
				<h6 className="prc-package__price">{data.costs}</h6>
				<span className="prc-package__cost-type">{getCostTypeLabel()}</span>
				<div className="prc-package__action">{getAction()}</div>
			</div>
			<div className="prc-package__content" ref={slideDownRef}>
				<div className="prc-package__description">
					<p className="prc-package__heading">{getLabel('package_content_heading_description')}</p>
					<p dangerouslySetInnerHTML={{ __html: data.content.description }} />
				</div>
				{data.content.duration && (
					<div className="prc-package__duration">
						<p className="prc-package__heading">{getLabel('package_content_heading_duration')}</p>
						<p dangerouslySetInnerHTML={{ __html: data.content.duration }} />
					</div>
				)}
				{packageFeatureListItems.length ? (
					<div className="prc-package__includes">
						<p className="prc-package__heading">{getLabel('package_content_heading_includes')}</p>
						<List items={packageFeatureListItems} />
					</div>
				) : null}
			</div>
		</li>
	);
}

Package.propTypes = {
	addPackage: PropTypes.func.isRequired,
	allowMultiple: PropTypes.bool.isRequired,
	data: PropTypes.object.isRequired,
	getLabel: PropTypes.func.isRequired,
	id: PropTypes.number.isRequired,
	paymentInterval: PropTypes.string.isRequired,
	removePackage: PropTypes.func.isRequired,
	selected: PropTypes.bool.isRequired,
};
